export default "__VITE_ASSET__bf930471__"